<p-dialog
  header="Edit Profile"
  [modal]="true"
  [style]="{ width: '80%' }"
  [draggable]="false"
  [(visible)]="editProfileModalService.modalVisible"
  (onHide)="close()"
>
  <div class="edit-profile-dialog-content">
    <div class="profile-image-container">
      <p-avatar class="avatar" icon="fa-solid fa-user" shape="circle"></p-avatar>
      <yt-y-button label="Add Photo" icon="fa-plus" iconPos="left" [text]="true"></yt-y-button>
    </div>
    <form>
      <div class="input-group">
        <label for="firstName">First Name</label>
        <input pInputText id="firstName" [formField]="profileForm.firstName" />
      </div>
      <div class="input-group">
        <label for="lastName">Last Name</label>
        <input pInputText id="lastName" [formField]="profileForm.lastName" />
      </div>
      <div class="input-group">
        <label for="role">Role</label>
        <input pInputText id="role" [formField]="profileForm.role" />
      </div>
      <div class="input-group">
        <label for="email">Email</label>
        <input pInputText id="email" [formField]="profileForm.email" />
      </div>
      <div class="input-group">
        <label for="phoneNumber">Phone Number</label>
        <yt-form-control
          [type]="FormControlType.InputMask"
          [formField]="profileForm.phoneNumber"
          [mask]="phoneValidationPattern()"
          [formErrors]="phoneFormErrors"
        ></yt-form-control>
      </div>
    </form>
  </div>

  <ng-template pTemplate="footer">
    <div class="actions">
      <yt-y-button label="Cancel" [text]="true" (click)="close()"></yt-y-button>
      <yt-y-button label="Save Changes" [disabled]="!profileForm().valid()" (click)="save()"></yt-y-button>
    </div>
  </ng-template>
</p-dialog>
